import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[120px] w-full glass-liquid-light border-border-glass-medium px-4 py-3 text-base font-inter",
        "placeholder:text-muted-foreground/60",
        "focus-visible:glass-liquid-medium focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:border-primary/50",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "liquid-morph rounded-2xl shadow-liquid-sm focus-visible:shadow-liquid-md resize-none",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
